import { render, staticRenderFns } from "./NumberWithLable.vue?vue&type=template&id=4ae90808&scoped=true&"
import script from "./NumberWithLable.vue?vue&type=script&lang=js&"
export * from "./NumberWithLable.vue?vue&type=script&lang=js&"
import style0 from "./NumberWithLable.vue?vue&type=style&index=0&id=4ae90808&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae90808",
  null
  
)

export default component.exports